import React, { useEffect, useState } from 'react';
import { client } from 'cccisd-apollo';
import { SecureMessagingMultipleConversations } from 'cccisd-laravel-secure-messaging';
import query from './Providers.graphql';
import style from './style.css';

function SecureMessagingSupervisor() {
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchProviders() {
            const response = await client.query({
                query,
                variables: {},
                fetchPolicy: 'network-only',
            });

            const instructorList = response.data.roles.instructorList;
            const newProvider = instructorList.map(instructor => ({
                id: instructor.pawn.pawnId,
                firstName: instructor.user.firstName,
                lastName: instructor.user.lastName,
                username: instructor.user.username,
            }));

            setProviders(newProvider);
            setLoading(false);
        }

        fetchProviders();
    }, []);

    if (loading) {
        return null;
    }

    const user = window.cccisd.fortress.user;
    const primaryParticipant = {
        id: user.pawnId,
        firstName: user.firstName,
        lastName: user.lastName,
        username: user.username,
    };

    if (providers.length === 0) {
        return (
            <div className="alert alert-warning">
                <p>
                    You are not linked to any providers. Once you are linked to a provider, you will be able to message
                    them here.
                </p>
            </div>
        );
    }

    return (
        <div className={style.messageBox}>
            <SecureMessagingMultipleConversations
                primaryParticipant={primaryParticipant}
                anotherParticipants={providers}
            />
        </div>
    );
}

export default SecureMessagingSupervisor;
